import { EndpointSetting } from "@/constants/app/type";
import { UserState } from "../type";
import { setCookie, setLocalStorage } from "@/utils/app/storage";

export const callbackRegist: EndpointSetting['caller'] = (
  state: UserState,
  action: any,
  endpointName: any
) => {
  const { loginToken, ...data } = action.payload
  state.regist.loading = false
  state.regist.error = null
  state.regist.success = true
  // state.profile.data = data
}